import React from 'react';

import { Paper } from '@mui/material';

import classes from './NgzCustomerGoHighLevelWidget.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { useCustomerGoHighLevelConnection } from './hooks/useCustomerGoHighLevelConnection';
import { ConnectionManagement } from './ConnectionManagement/ConnectionManagement';
import { TitleSection } from './TitleSection/TitleSection';

type NgzCustomerGoHighLevelWidgetProps = {
  customerId: number;
};

const NgzCustomerGoHighLevelWidget = ({
  customerId,
}: NgzCustomerGoHighLevelWidgetProps) => {
  const { accountInfo, refreshConnectionInfo } =
    useCustomerGoHighLevelConnection(customerId);

  return (
    <Paper variant="boxWithPadding" className={classes.box}>
      <TitleSection contactId={accountInfo?.contactId} />
      <ConnectionManagement
        contactId={accountInfo?.contactId}
        onRefresh={refreshConnectionInfo}
      />
    </Paper>
  );
};

angularizeWithProviders(NgzCustomerGoHighLevelWidget, 'ngzCustomerGoHighLevelWidget', {
  customerId: '<',
});

export { NgzCustomerGoHighLevelWidget };
